<template>
  <div class="candidates-component">
    <div class="page-layout__group">
      <div class="section__controls">
        <button v-if="hasPermission('api.application.profile.addCandidate') && !app.fromNrk && app.status==='NEW'" class="btn btn--main btn--sm" @click="searchCandidate">
          + {{ getTranslation('addCandidate') }}
        </button>
        <div v-if="hasPermission('api.application.profile.generateTokenList') && app.status ==='CONFIRMED' && !app.isFinished" class="btn  btn--white btn--system  p-0">

          <select class="btn__select" v-model="tokenListFormat">
            <option :value="formats.excel">{{ formats.excel }}</option>
            <option :value="formats.pdf">{{ formats.pdf }}</option>
          </select>

          <a @click="generateTokenList(tokenListFormat)" class="btn__link" href="javascript:void(0)">
            {{ getTranslation('generateTokenList') }}
          </a>
        </div>
        <div v-if="hasPermission('api.application.profile.registrationList') && app.status ==='CONFIRMED' && !app.isFinished" class="btn  btn--white  btn--system  p-0">

          <select class="btn__select" v-model="registrationListFormat">
            <option :value="formats.excel">{{ formats.excel }}</option>
            <option :value="formats.pdf">{{ formats.pdf }}</option>
          </select>

          <a @click="downloadRegistrationList(registrationListFormat)" class="btn__link" href="javascript:void(0)">
            {{ getTranslation('registrationList') }}
          </a>
        </div>
      </div>

      <table class="table  table--noborder mt-2 table-zebra">
        <thead class="table__head">
        <tr class="table__row">
          <td class="table__cell  table__hcell">
            <form @submit.prevent="fetchApplicationCandidates(appId)">
              <div class="field-advanced">
                <div class="field-advanced__inner">
                  <div class="field-advanced__field-wrap">
                    <input type="text" :placeholder="getTranslation('searchByfioPin')" v-model="filterForm.query"
                           class="field  field--full-width  field--bg-grey  js-borderOnFocus"></div>
                  <div class="field-advanced__right">
                    <button class="btn  btn--square  btn--main">
                      <svg class="btn__icon">
                        <use xlink:href="#icon__search"></use>
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </td>
          <td class="table-3__cell  table__hcell">
            <v-select
                :options="formOptions.notificationStatuses"
                label="title"
                v-model="filterForm.notificationStatus"
                :reduce="option=>option.id"
                :placeholder="getTranslation('selectFromList')"
            />
          </td>
          <td class="table-3__cell  table__hcell">
            <v-select
                :options="formOptions.dispatch"
                label="title"
                v-model="filterForm.dispatchStatus"
                :reduce="option=>option.id"
                :placeholder="getTranslation('selectFromList')"
            />
          </td>
        </tr>
        <tr class="table__row">
          <th class="table__cell  table__hcell" style="width:40%">{{ getTranslation('candidates') }} -
            {{ pagination.total }}
          </th>
          <th class="table__cell  table__hcell" style="width:20%">{{ getTranslation('notification') }}</th>
          <th class="table__cell  table__hcell" style="width:20%">{{ getTranslation('status') }}</th>
          <th class="table__cell  table__hcell" style="width: 0.2%;"></th>
        </tr>
        </thead>
        <tbody class="table__body">
        <tr v-for="item in candidates" v-bind:key="item.id" class="table__row">
          <td class="table__cell">
            <!-- PERSON -->
            <div class="person">
              <div class="person__inner">
                <div class="person__img"
                     :class="{'person__img--online':item.isOnline,'person__img--offline':!item.isOnline}">
                  <a href="javascript:void(0)">
                    <img :src="item.photoUrl || $config.noAvatarUrl" alt="Фото сотрудника">
                  </a>
                </div>

                <div class="person__info">
                  <h3 class="person__name">
                    <router-link class="person__link" :to="{name:'api.candidate.get',params:{id:item.id}}">
                      {{ item.fullName }}
                    </router-link>
                  </h3>
                  <div class="person__descr">{{ item.pin }}</div>
                  <div class="person__descr">
                    <span v-if="item.email">{{ item.email }}</span>
                    <span v-else class="text--danger">{{ getTranslation('noCandidateEmail') }}</span>
                  </div>
                </div>
              </div>
            </div>
            <!-- / PERSON -->
          </td>
          <td class="table__cell">
            <NotificationStatus v-if="item.notificationStatus" :status="item.notificationStatus"/>
          </td>
          <td class="table__cell">
            <span v-if="item.dispatchStatus" class="badge" :class="{'badge--warning':item.hasToRetake}">
              {{ getTranslation(item.hasToRetake ? 'candidate_retake_not_dispatched' : 'candidate_dispatched') }}
            </span>
            <span v-else class="badge badge--accent">
              {{ getTranslation('candidate_not_dispatched') }}
            </span>
          </td>

          <td class="table__cell">
            <ActionsComponent
                :has-delete="app.status==='NEW' && hasPermission('api.application.profile.removeCandidate')"
                v-on:delete="deleteCandidate(appId,item.pin)" v-on:password="generateToken(item.pin,item.fullName)"
                :has-password="hasPermission('api.application.profile.generateToken')" :has-edit="app.status==='NEW'"
                v-on:edit="updateCandidate(item)"
                :options="{
                                        notifyTestingDate:hasPermission('api.candidate.profile.notifyCandidate') && app.status === 'CONFIRMED' && item.dispatchStatus && !item.eventIsPassed,
                                        notifyTestingCancel:hasPermission('api.candidate.profile.notifyCandidate') && app.status === 'CONFIRMED' && !item.dispatchStatus
                                    }"
                v-on:notifyTestingDate="sendNotification(appId,item.id)"
                v-on:notifyTestingCancel="sendNotification(appId,item.id,'event_cancel')"
            />
          </td>
        </tr>
        <tr v-if="pagination.total===0" class="table__row">
          <td class="table__cell empty">
            {{ getTranslation('noResults') }}
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <div class="page-layout__pagination" v-if="pagination.total && pagination.lastPage > 1">
      <pagination :pagination="pagination"
                  @change="()=>{fetchApplicationCandidates(this.appId);this.$scrollTo('.candidates-component');}"
                  v-model="filterForm.page"></pagination>
    </div>
    <!-- /.table -->
    <!-- modal candidate -->
    <modal
        v-model="showModal"
        :modal-title="edit ? getTranslation('edit'):getTranslation('add')"
        :ok-button-label="showCandidateInfo ? getTranslation('save'):''"
        :cancel-button-label="getTranslation('cancel')"
        @ok-button-click="addCandidate"
        @cancelButtonClick="resetModal"
        @input="resetModal"
    >
      <form @submit.prevent="searchPin" class="form w-100">
        <div v-if="!edit" class="form__group">
          <label class="form__label form__label--block mb-2" for="pin">{{ getTranslation('pin') }}</label>
          <div class="field-advanced field-advanced--fixed">
            <div class="field-advanced__inner">
              <div class="field-advanced__field-wrap">
                <input maxlength="14" v-model.trim="pin" type="text" id="pin"
                       class="field  field--bg-grey  js-borderOnFocus" :class="{'field--error': $v.pin.$error}">
              </div>
              <div class="field-advanced__right">
                <a href="javascript:void(0)" @click="searchPin" class="btn  btn--square  btn--main">
                  <svg class="btn__icon">
                    <use xlink:href="#icon__search"></use>
                  </svg>
                </a>
              </div>
            </div>
          </div>
          <div v-if="$v.pin.$error" class="form__error">{{ getTranslation('requiredField') }}<span
              class="required">*</span></div>
        </div>
        <div v-if="showCandidateInfo">
          <section class="section  employee-card  employee-card-expanded col-md-8">
            <div class="employee-card__inner">
              <div class="employee-card__header">
                <h2 class="employee-card__title">{{ candidate.fullName }}</h2>
              </div>

              <div class="employee-card__left">
                <div class="employee-card__body">
                  <div class="person">
                    <div class="person__inner">
                      <div v-if="showAvatar" class="person__img--3x4 mr-3">
                        <img v-if="candidate.photoId" :src="candidate.photoUrl"/>
                        <img v-else-if="candidate.photoBase64"
                             :src="'data:image/png;base64, ' + candidate.photoBase64"/>
                        <img v-else :src="$config.noProfilePhotoUrl"/>
                        <button type="button" @click="$refs.avatarSelect.click()" class="btn btn--main btn--sm"
                                style="margin-top:-40px;width:100%;opacity: 0.9">{{ getTranslation('select') }}
                        </button>
                        <input @change="uploadAvatar" style="display: none" ref="avatarSelect" type="file"
                               accept="image/*"/>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="employee-card__right">
                <div class="employee-card__body">
                  <div class="person">
                    <div class="person__inner">
                      <table class="table-doc">
                        <tbody>
                        <tr>
                          <th class="table-doc__cell  table-doc__cell--head" style="width: 190px;">
                            {{ getTranslation('bdate') }}
                          </th>
                          <td class="table-doc__cell">{{ dateFormat(candidate.dateOfBirth) }}</td>
                        </tr>
                        <tr>
                          <th class="table-doc__cell  table-doc__cell--head" style="width: 190px;">
                            {{ getTranslation('gender') }}
                          </th>
                          <td class="table-doc__cell">{{ candidate.genderText }}</td>
                        </tr>
                        <tr>
                          <th class="table-doc__cell  table-doc__cell--head" style="width: 190px;">
                            {{ getTranslation('email') }}
                          </th>
                          <td class="table-doc__cell">
                            <input class="field" type="text" v-model.trim="candidate.email"
                                   :class="{'field--error': $v.candidate.email.$error}"/>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>

                  </div>
                </div>
              </div>


            </div>
          </section>
        </div>
      </form>
    </modal>
    <!-- modal password -->
    <modal
        v-model="showPasswordModal"
        :modal-title="getTranslation('add')"
        :ok-button-label="getTranslation('save')"
        :cancel-button-label="getTranslation('cancel')"
        @ok-button-click="saveToken"
        @cancelButtonClick="resetPasswordModal"
        @input="resetPasswordModal"
    >
      <form>
        <div class="form__group">
          <label class="auth-form__label  form__label  form__label--block" for="login">
            {{ getTranslation('username') }}
          </label>

          <input readonly v-model="pin" class="field field--full-width" :class="{ 'field--error': $v.pin.$error }"
                 type="text" id="login">
          <div v-if="$v.pin.$error" class="form__error">{{ getTranslation('requiredField') }}</div>
        </div>
        <div class="form__group">
          <label class="auth-form__label  form__label  form__label--block" for="password">
            {{ getTranslation('password') }}
          </label>
          <input v-model="token" class="field field--full-width" :class="{ 'field--error': $v.token.$error }"
                 type="text" id="password">
          <div v-if="$v.token.$error" class="form__error">{{ getTranslation('requiredField') }}</div>
        </div>

        <div class="form__group">
          <a href="javascript:void(0)" @click="token = makeId(8)"
             class="btn btn--main-outline btn--sm">{{ getTranslation('generatePassword') }}</a>
        </div>
      </form>
    </modal>
  </div>
</template>

<script>
import applicationMixin from "../mixins/application";
import {required} from "vuelidate/lib/validators";
import {email} from "vuelidate/lib/validators";
import candidateProfileMixin from "@/views/admin/candidates/mixins/CandidateProfile";
import NotificationStatus from "./NotificationStatusComponent";
import reportMixin from "@/views/admin/reports/mixins/report";

export default {
  name: "CandidatesComponent",
  components: {NotificationStatus},
  props: ['appId', 'app', 'active'],
  mixins: [applicationMixin, candidateProfileMixin, reportMixin],
  data() {
    return {
      tokenListFormat: '.xlsx',
      registrationListFormat: '.xlsx',
      showModal: false,
      edit: false,
      showPasswordModal: false,
      pin: '',
      fullName: '',
      showCandidateInfo: false,
      token: '',
      email: '',
      formOptions: {
        gender: [],
        dispatch: []
      },
      showAvatar: true,
      appCandidate: {
        id: '',
        pin: '',
        fname: '',
        lname: '',
        pname: '',
        email: '',
        bdate: '',
      },
      pagination: {
        total: '',
        lastPage: '',
        currentPage: ''
      },
    }
  },
  created() {
    if (this.active)
      this.fetchApplicationCandidates(this.appId);

    this.fetchAppCandidateOptions();
  },
  watch: {

    'filterForm.gender'() {
      this.fetchApplicationCandidates(this.appId);
    },

    'filterForm.dispatchStatus'() {
      this.fetchApplicationCandidates(this.appId);
    },
    'filterForm.notificationStatus'() {
      this.fetchApplicationCandidates(this.appId);
    },
    active(val) {
      if (val)
        this.fetchApplicationCandidates(this.appId);
    },
    showCandidateInfo(val) {
      if (val)
        this.candidate.email = this.email;
    }

  },
  methods: {
    fetchAppCandidateOptions() {
      this.axios.get(this.$config.urls.candidate.appCandidateOptions.url)
          .then(response => {
            this.formOptions.gender = this.objectToArray(response.data.data.gender, true);
            this.formOptions.dispatch = this.objectToArray(response.data.data.dispatch, false, true);
            this.formOptions.notificationStatuses = response.data.data.notificationStatuses.map(item => {
              return {
                id: item,
                title: this.getTranslation('NOTIFICATION_' + item)
              }
            });
          }).catch(() => {
      });
    },

    downloadRegistrationList(format = '.xlsx') {

      this.axios.get(this.$config.urls.application.downloadRegistrationList.url.replace(':id', this.appId), this.getAxiosConfig({format: format})
      ).then(response => {

        this.createDownloadLink(response, 'registrationList', format);

      }).catch(() => {
      });
    },

    sendNotification(appId, candidateId, type = 'testing_candidate_date') {
      Swal.fire({
        title: this.getTranslation('areYouSure'),
        text: this.getTranslation('cantRevertMsg'),
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: this.getTranslation('cancel'),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.getTranslation('ImSure')
      }).then((result) => {
        if (result.value) {
          this.notifyCandidate(appId, candidateId, type).then(() => {

            setTimeout(() => {
              this.fetchApplicationCandidates(this.appId);
            }, 3000)

          })
        }
      });
    },

    generateTokenList(format = '.xlsx') {

      return this.axios.get(this.$config.urls.application.generateTokenList.url.replace(':id', this.appId), this.getAxiosConfig({format: format}))
          .then(response => {
            this.createDownloadLink(response, 'generateTokenList', format);
          }).catch(() => {
          });
    },

    generateToken(pin, fullName) {
      this.pin = pin;
      this.fullName = fullName;
      this.showPasswordModal = true;
    },

    saveToken() {
      this.$v.pin.$touch();
      this.$v.token.$touch();
      if (this.$v.pin.$invalid || this.$v.token.$invalid)
        return this.snotifyError('wrongFormMsg');

      this.saveAppToken(this.appId, {pin: this.pin, token: this.token}).then(response => {

        this.resetPasswordModal();

        const link = document.createElement('a');
        link.href = response.data.data.file;
        link.setAttribute('download', this.fullName + ' - ' + this.$moment().format('DD.MM.YYYY HH:mm') + '.pdf');
        document.body.appendChild(link);
        link.click();
      }).catch(() => {
      });

    },

    addCandidate() {
      this.candidateForm = {
        candidateId: this.candidate.candidateId,
        fname: this.candidate.name,
        email: this.candidate.email,
        sname: this.candidate.surname,
        pname: this.candidate.patronymic,
        bdate: this.candidate.dateOfBirth,
        pin: this.candidate.pin,
        gender: this.candidate.gender,
        photoBase64: this.candidate.photoBase64,
        photoId: this.candidate.photoId,
      };
      this.$v.candidate.$touch();
      this.$v.pin.$touch();

      if (this.$v.candidate.$invalid || this.$v.pin.$invalid)
        return this.snotifyError('wrongFormMsg');

      this.saveCandidate(this.$route.params.id).then(() => {
        this.resetModal();
        this.fetchApplicationCandidates(this.appId);
      }).catch(() => {
        this.fetchApplicationCandidates(this.appId);
      });
    },

    searchCandidate() {
      this.showCandidateInfo = false;
      this.showModal = true;
    },

    updateCandidate(candidate) {
      this.showModal = true;
      this.edit = true;
      this.pin = candidate.pin;
      this.email = candidate.email;
      this.searchPin().then(() => {
        this.candidate.candidateId = candidate.id;
      });
    },

    searchPin() {
      this.$v.pin.$touch();

      if (this.$v.pin.$invalid)
        return this.snotifyError('wrongFormMsg');

      return this.pinService(this.pin).then(result => {

        this.candidate = result;
        this.candidate.photoBase64 = result.photo;
        this.candidate.fullName = result.surname + ' ' + result.name;

        if (result.patronymic)
          this.candidate.fullName += ' ' + result.patronymic;

        this.fetchApplicationCandidates(this.appId, this.pin).then(() => {
          this.$nextTick(() => {
            this.email = this.appCandidate.email;
          })
        }).then(() => {

          this.showCandidateInfo = true;
        }).catch(() => {
        });

      })
          .catch(() => {
            this.resetCandidateForm();
            this.showCandidateInfo = false;
            return this.snotifyError('wrongPin');
          });
    },

    resetModal() {
      this.$v.$reset();
      this.showModal = false;
      this.edit = false;
      this.email = '';
      this.showPasswordModal = false;
      this.showCandidateInfo = false;
      this.resetCandidateForm();
    },

    resetCandidateForm() {
      this.pin = '';
      this.fullName = '';
      this.appCandidate = {};
      this.candidate = {
        candidateId: null,
        pin: '',
        fname: '',
        email: '',
        fullName: '',
        lname: '',
        pname: '',
        bdate: '',
        photoId: '',
      };
      this.candidateForm = {
        candidateId: null,
        pin: '',
        email: '',
        fname: '',
        fullName: '',
        lname: '',
        pname: '',
        bdate: '',
        photoId: '',
      };
    },

    resetPasswordModal() {
      this.$v.$reset();
      this.showPasswordModal = false;
      this.pin = '';
      this.token = '';
    }
  },
  validations: {
    pin: {
      required
    },
    token: {
      required
    },
    candidate: {
      pin: {
        required
      }
      ,
      name: {
        required
      }
      ,
      surname: {
        required
      }
      ,
      dateOfBirth: {
        required
      },
      gender: {
        required
      },
      email: {
        email
      }
    }
  }
}
</script>

<style scoped>
.field-advanced__field-wrap {
  border: 1px solid #7fb0ff;
  border-radius: 4px 0 0 4px;
  margin-left: 3px;
}
</style>
